import React from 'react';
import "./floorplans.css"

const Floorplans = (props) => {
    return ( <>
    <div className='fpdiv'>
        <h2 className='fdtext'>{props.fdtext}</h2>
        <h2 className='fdsize'>{props.fdsize}</h2>
    </div> 
    </> );
}
 
export default Floorplans;